export default "__VITE_ASSET__3qz03Z17__"